export const config = {
    appName: 'Сытый',
    supportEmail: 'support@example.com',
    server: 'https://sitiy-api.ru/api/',
    apiUrl: 'https://sitiy-api.ru/api/v1/admin',
    graphUrl: 'https://sitiy-api.ru/api/graphql/5496880-8345687-2394984-221781/admin',
    
    // URL для проверки версии приложения
    versionUrl: 'https://sitiy.ru/version.json', // Замените на ваш URL хостинга
  
    yandexMapApiKey: '32a35624-b004-474d-b343-426da5feddae', // sergey.kovalenko@sitiy.ru
    yandexMapGeocodeApiKey: '32a35624-b004-474d-b343-426da5feddae', // sergey.kovalenko@sitiy.ru
    
    socialLinks: {
        tg: 'https://t.me/+79914590879',
        vk: 'https://vk.com/sitiy_ru',
        inst: 'https://www.instagram.com/sitiy_tlt/'
    },

    appLinks: {
        appstore: 'https://itunes.apple.com/us/app/%D1%81%D1%8B%D1%82%D1%8B%D0%B9-%D0%BE%D1%84%D0%B8%D1%81-%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B0-%D0%BE%D0%B1%D0%B5%D0%B4%D0%BE%D0%B2/id1361986950?l=ru&ls=1&mt=8',
        playmarket: 'https://play.google.com/store/apps/details?id=air.com.menu4me.dinner.sitiyoffice',
        rustore: 'https://apps.rustore.ru/app/air.com.menu4me.dinner.sitiyoffice',
    },
};

export const partnerConfigs = {
    0: {
        id: 0,
        logo: '',
        name: '',
        description: '',
        cityId: null,
        cityName: '',
        address: '',
        contactPhones: [],
        contactEmail: '',
        socialLinks: {
            vk: '',
            instagram: '',
        },
        openingHours: '',
    },
    240289: {
        id: 240289,
        logo: 'https://stolovkin58.ru/pictures/logo_20230918162310.png',
        name: 'СтоловкинЪ',
        description: '',
        cityId: 35,
        cityName: 'Пенза',
        address: 'г. Пенза, проспект Победы, 75Р',
        contactPhones: ['+79272894680'],
        contactEmail: '',
        socialLinks: {
            vk: 'https://vk.com/stolovkin58',
            instagram: '',
        },
        openingHours: 'Пн-Пт 11:00 - 14:00',
    },
    245482: {
        id: 245482,
        logo: '',
        name: 'Кафе - столовая "Виват"',
        description: '',
        cityId: 18,
        cityName: 'Тольятти',
        address: 'г. Тольятти, Южное шоссе 137 (главный корпус Паркового комплекса истории техники им. К.Г. Сахарова)',
        contactPhones: ['+79613900029', '+79061282334', '+79178272322'],
        contactEmail: null,
        socialLinks: {
            vk: null,
            instagram: null,
        },
        openingHours: 'Ежедневно с 10-00 до 16-00',
    },
    245692: {
        id: 245692,
        logo: '',
        name: 'Столовая "Сядь, поешь"',
        description: '',
        cityId: 35,
        cityName: 'Пенза',
        address: '',
        contactPhones: [],
        contactEmail: null,
        socialLinks: {
            vk: null,
            instagram: null,
        },
        openingHours: '',
    },
};
